import React from "react";
import {RichText} from "@montana/shared/rich-text";
import {IM10BannerCardBlock, IM24CompositionCard} from "@montana/models/generated/cms.interface";
import {M10BannerCardComponent} from "@montana/shared/m10-banner-card/m10-banner-card.component";
import {CompositionCard} from "@montana/shared/composition-card/composition-card.component";

export interface IColourPageGrid {
    header?: string;
    blocks?: any[];
}

type GridBlock = {
    data?: IM10BannerCardBlock | IM24CompositionCard
    index?: number
}


export function ColourPageGrid(props: IColourPageGrid) {
    const {header, blocks} = props;

    function GridBlock({data, index}: GridBlock) {
        if (!data || index === undefined) return (<></>)

        if (data?.kind === 'M10BannerCardBlock') {
            return (<div
                className={`color-page-grid__block color-page-grid__block--${index % 3 === 0 ? 'large' : 'small'}`}>
                <M10BannerCardComponent {...data} mediaDisplayRatio="portrait" truncateDescription={2} /></div>);
        }
        if (data?.kind == 'M24CompositionCard') {
            return (
                <div
                    className={`color-page-grid__block color-page-grid__block--${index % 3 === 0 ? 'large' : 'small'}`}>
                    <CompositionCard {...data} />
                </div>)
        }
        return (<></>)
    }

    return (
        <div className="color-page-grid">
            {header && <RichText className="color-page-grid__header" text={header}/>}
            <section className="color-page-grid__content">
                {blocks?.map((block, index) => (
                    <GridBlock data={block} key={block.epiId} index={index}/>
                ))}
            </section>
        </div>
    )
}